(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-pw-colour-finder]');
  if (!roots.length) return;

  function clamp(value, minimum, maximum) { return Math.max(minimum, Math.min(maximum, value)); }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
  function validHex(value) { return /^#[0-9a-f]{6}$/i.test(String(value || '')); }
  function componentHex(value) { return clamp(Math.round(value), 0, 255).toString(16).padStart(2, '0'); }
  function rgbHex(red, green, blue) { return ('#' + componentHex(red) + componentHex(green) + componentHex(blue)).toUpperCase(); }
  function hexRgb(hex) {
    return {
      r: parseInt(hex.slice(1, 3), 16),
      g: parseInt(hex.slice(3, 5), 16),
      b: parseInt(hex.slice(5, 7), 16)
    };
  }
  function rgbHsl(red, green, blue) {
    red /= 255; green /= 255; blue /= 255;
    var maximum = Math.max(red, green, blue), minimum = Math.min(red, green, blue);
    var delta = maximum - minimum, hue = 0, lightness = (maximum + minimum) / 2;
    var saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));
    if (delta) {
      if (maximum === red) hue = 60 * (((green - blue) / delta) % 6);
      else if (maximum === green) hue = 60 * (((blue - red) / delta) + 2);
      else hue = 60 * (((red - green) / delta) + 4);
    }
    return { h: hue < 0 ? hue + 360 : hue, s: saturation, l: lightness };
  }
  function rgbHsv(red, green, blue) {
    red /= 255; green /= 255; blue /= 255;
    var maximum = Math.max(red, green, blue), minimum = Math.min(red, green, blue);
    var delta = maximum - minimum, hue = 0;
    if (delta) {
      if (maximum === red) hue = 60 * (((green - blue) / delta) % 6);
      else if (maximum === green) hue = 60 * (((blue - red) / delta) + 2);
      else hue = 60 * (((red - green) / delta) + 4);
    }
    return {
      h: hue < 0 ? hue + 360 : hue,
      s: maximum ? delta / maximum * 100 : 0,
      v: maximum * 100
    };
  }
  function hsvHex(hue, saturation, value) {
    var h = ((Number(hue) || 0) % 360 + 360) % 360;
    var s = clamp(Number(saturation) || 0, 0, 100) / 100;
    var v = clamp(Number(value) || 0, 0, 100) / 100;
    var chroma = v * s, segment = h / 60;
    var secondary = chroma * (1 - Math.abs(segment % 2 - 1));
    var red = 0, green = 0, blue = 0;
    if (segment < 1) { red = chroma; green = secondary; }
    else if (segment < 2) { red = secondary; green = chroma; }
    else if (segment < 3) { green = chroma; blue = secondary; }
    else if (segment < 4) { green = secondary; blue = chroma; }
    else if (segment < 5) { red = secondary; blue = chroma; }
    else { red = chroma; blue = secondary; }
    var match = v - chroma;
    return rgbHex((red + match) * 255, (green + match) * 255, (blue + match) * 255);
  }
  function familyHueRange(value) {
    var key = String(value || '').trim().toLowerCase();
    var ranges = {
      red: { start: 345, end: 375 },
      pink: { start: 315, end: 375 },
      purple: { start: 250, end: 315 },
      blue: { start: 195, end: 250 },
      navy: { start: 215, end: 250 },
      green: { start: 85, end: 165 },
      turquoise: { start: 165, end: 195 },
      teal: { start: 165, end: 205 },
      yellow: { start: 42, end: 68 },
      orange: { start: 15, end: 42 },
      brown: { start: 10, end: 35 },
      beige: { start: 25, end: 50 },
      cream: { start: 35, end: 60 },
      ivory: { start: 35, end: 60 },
      gold: { start: 35, end: 55 },
      khaki: { start: 45, end: 80 },
      burgundy: { start: 330, end: 360 },
      maroon: { start: 330, end: 360 },
      black: { start: 0, end: 359, maxSaturation: 12, neutral: true },
      white: { start: 0, end: 359, maxSaturation: 8, neutral: true },
      grey: { start: 0, end: 359, maxSaturation: 12, neutral: true },
      gray: { start: 0, end: 359, maxSaturation: 12, neutral: true },
      silver: { start: 0, end: 359, maxSaturation: 10, neutral: true }
    };
    return ranges[key] || null;
  }
  function hueForRange(hue, range) {
    var normalised = ((Number(hue) || 0) % 360 + 360) % 360;
    if (!range) return normalised;
    var midpoint = (range.start + range.end) / 2;
    var candidates = [normalised - 360, normalised, normalised + 360];
    var closest = candidates[0];
    candidates.forEach(function (candidate) {
      if (Math.abs(candidate - midpoint) < Math.abs(closest - midpoint)) closest = candidate;
    });
    return clamp(closest, range.start, range.end);
  }
  function familyHueGradient(range) {
    if (!range) return '';
    if (range.neutral) return 'linear-gradient(90deg, #f5f5f2 0%, #a8aaa8 48%, #171817 100%)';
    var stops = [];
    for (var step = 0; step <= 6; step++) {
      var hue = range.start + ((range.end - range.start) * step / 6);
      stops.push('hsl(' + (((hue % 360) + 360) % 360) + ' 88% 54%) ' + Math.round(step / 6 * 100) + '%');
    }
    return 'linear-gradient(90deg, ' + stops.join(', ') + ')';
  }
  function friendlyName(hex) {
    var rgb = hexRgb(hex), hsl = rgbHsl(rgb.r, rgb.g, rgb.b);
    if (hsl.l < .13) return 'Black';
    if (hsl.l > .92 && hsl.s < .12) return 'White';
    if (hsl.s < .1) return hsl.l < .35 ? 'Charcoal' : hsl.l < .72 ? 'Grey' : 'Silver';
    if (hsl.h < 15 || hsl.h >= 345) return hsl.l < .38 ? 'Burgundy' : 'Red';
    if (hsl.h < 42) return hsl.l > .72 ? 'Peach' : 'Orange';
    if (hsl.h < 68) return hsl.l > .8 ? 'Cream' : 'Yellow';
    if (hsl.h < 85) return 'Lime';
    if (hsl.h < 165) return hsl.l < .32 ? 'Forest Green' : 'Green';
    if (hsl.h < 195) return 'Turquoise';
    if (hsl.h < 218) return hsl.l > .68 ? 'Sky Blue' : 'Denim Blue';
    if (hsl.h < 252) return hsl.l < .32 ? 'Navy' : 'Royal Blue';
    if (hsl.h < 285) return 'Purple';
    if (hsl.h < 330) return hsl.l > .66 ? 'Pink' : 'Magenta';
    return 'Burgundy';
  }

  function nominalColourPickerHex(colour) {
    var colours = {
      black: '#111314', white: '#FBFAF5', grey: '#8F9692', gray: '#8F9692',
      blue: '#496FAC', green: '#447757', red: '#B9353C', pink: '#D890AA',
      brown: '#74513D', beige: '#D9C3A5', purple: '#71518B', yellow: '#E3BF31',
      orange: '#DF722D', cream: '#EEECD9', navy: '#17243F', gold: '#C0A24C',
      silver: '#C6C8C7', charcoal: '#47534E', turquoise: '#38BFC5',
      burgundy: '#782C36', lime: '#9DAA71', khaki: '#9A8F68',
      multicoloured: '#7A6A91', multi: '#7A6A91'
    };
    return colours[String(colour || '').trim().toLowerCase()] || '';
  }

  function rgbLab(red, green, blue) {
    var rgb = [red / 255, green / 255, blue / 255];
    for (var channel = 0; channel < 3; channel++) {
      rgb[channel] = rgb[channel] > .04045
        ? Math.pow((rgb[channel] + .055) / 1.055, 2.4)
        : rgb[channel] / 12.92;
    }
    var x = (rgb[0] * .4124564 + rgb[1] * .3575761 + rgb[2] * .1804375) / .95047;
    var y = rgb[0] * .2126729 + rgb[1] * .7151522 + rgb[2] * .072175;
    var z = (rgb[0] * .0193339 + rgb[1] * .119192 + rgb[2] * .9503041) / 1.08883;
    function transform(value) {
      return value > .008856451679
        ? Math.pow(value, 1 / 3)
        : (7.787037037 * value) + (16 / 116);
    }
    var fx = transform(x), fy = transform(y), fz = transform(z);
    return [(116 * fy) - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }

  function labDistance(left, right) {
    return Math.sqrt(
      Math.pow(left[0] - right[0], 2) +
      Math.pow(left[1] - right[1], 2) +
      Math.pow(left[2] - right[2], 2)
    );
  }

  function dominantPhotoColours(canvas) {
    var width = canvas.width, height = canvas.height;
    if (width < 2 || height < 2) return [];
    var pixels = canvas.getContext('2d', { willReadFrequently: true })
      .getImageData(0, 0, width, height).data;

    function pixel(x, y) {
      var offset = ((y * width) + x) * 4;
      return [pixels[offset], pixels[offset + 1], pixels[offset + 2], pixels[offset + 3]];
    }

    var insetX = Math.min(2, Math.max(0, width - 1));
    var insetY = Math.min(2, Math.max(0, height - 1));
    var corners = [
      pixel(insetX, insetY),
      pixel(Math.max(0, width - 1 - insetX), insetY),
      pixel(insetX, Math.max(0, height - 1 - insetY)),
      pixel(Math.max(0, width - 1 - insetX), Math.max(0, height - 1 - insetY))
    ];
    var backgroundRgb = [0, 0, 0];
    corners.forEach(function (corner) {
      backgroundRgb[0] += corner[0];
      backgroundRgb[1] += corner[1];
      backgroundRgb[2] += corner[2];
    });
    var background = rgbLab(
      backgroundRgb[0] / 4,
      backgroundRgb[1] / 4,
      backgroundRgb[2] / 4
    );
    var backgroundLooksPlain = background[0] > 72 &&
      Math.sqrt(background[1] * background[1] + background[2] * background[2]) < 22;
    var step = Math.max(1, Math.floor(Math.max(width, height) / 48));
    var all = [], foreground = [];

    for (var y = 0; y < height; y += step) {
      for (var x = 0; x < width; x += step) {
        var rgba = pixel(x, y);
        // Canvas alpha runs 0..255; this mirrors the server's GD alpha guard.
        if (rgba[3] < 35) continue;
        var lab = rgbLab(rgba[0], rgba[1], rgba[2]);
        // Keep the sampled position with the colour. This lets the photo
        // picker show where each suggested colour was actually found.
        var point = [lab[0], lab[1], lab[2], rgba[0], rgba[1], rgba[2], x, y];
        all.push(point);
        if (!backgroundLooksPlain || labDistance(lab, background) >= 8) {
          foreground.push(point);
        }
      }
    }

    var points = foreground.length >= Math.max(60, Math.floor(all.length * .08))
      ? foreground : all;
    if (points.length < 20) return [];
    var sorted = points.slice().sort(function (left, right) {
      return left[0] - right[0];
    });
    var centres = [sorted[Math.floor(sorted.length / 2)].slice()];

    while (centres.length < 12) {
      var best = null, bestDistance = -1;
      points.forEach(function (point) {
        var nearest = Infinity;
        centres.forEach(function (centre) {
          nearest = Math.min(nearest, labDistance(point, centre));
        });
        if (nearest > bestDistance) {
          bestDistance = nearest;
          best = point;
        }
      });
      if (!best || bestDistance < 3) break;
      centres.push(best.slice());
    }

    var assignments = [];
    for (var iteration = 0; iteration < 6; iteration++) {
      var sums = centres.map(function () { return [0, 0, 0, 0, 0, 0, 0]; });
      points.forEach(function (point, pointIndex) {
        var nearestIndex = 0, nearestDistance = Infinity;
        centres.forEach(function (centre, centreIndex) {
          var distance = labDistance(point, centre);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = centreIndex;
          }
        });
        assignments[pointIndex] = nearestIndex;
        for (var channel = 0; channel < 6; channel++) {
          sums[nearestIndex][channel] += point[channel];
        }
        sums[nearestIndex][6] += 1;
      });
      centres.forEach(function (centre, centreIndex) {
        if (sums[centreIndex][6] < 1) return;
        for (var channel = 0; channel < 6; channel++) {
          centre[channel] = sums[centreIndex][channel] / sums[centreIndex][6];
        }
      });
    }

    return centres.map(function (centre, centreIndex) {
      var members = assignments.filter(function (assignment) {
        return assignment === centreIndex;
      }).length;
      if (members < Math.max(4, Math.floor(points.length * .0075))) return null;
      var representative = null, representativeDistance = Infinity;
      points.forEach(function (point, pointIndex) {
        if (assignments[pointIndex] !== centreIndex) return;
        var distance = labDistance(point, centre);
        if (distance < representativeDistance) {
          representativeDistance = distance;
          representative = point;
        }
      });
      return {
        hex: rgbHex(centre[3], centre[4], centre[5]),
        coverage: members / Math.max(1, points.length),
        x: representative ? representative[6] / Math.max(1, width - 1) : .5,
        y: representative ? representative[7] / Math.max(1, height - 1) : .5
      };
    }).filter(function (cluster) {
      return !!cluster;
    }).sort(function (left, right) {
      return right.coverage - left.coverage;
    }).slice(0, 12);
  }
  function colourMatchPercentage(match) {
    match = match || {};
    var suppliedPercentage = Number(match.matchPercentage);
    if (isFinite(suppliedPercentage)) {
      return Math.max(0, Math.min(100, Math.round(suppliedPercentage)));
    }
    var distance = Number(match.distance);
    if (!isFinite(distance)) return '';
    var distanceScore = 100 / (1 + Math.pow(distance / 15, 2));
    var coverage = Number(match.coverage);
    var coverageFactor = isFinite(coverage)
      ? .72 + .28 * Math.min(1, Math.max(0, coverage) / .55)
      : 1;
    var rank = Math.max(1, Number(match.dominanceRank || 1));
    var rankFactor = rank === 1 ? 1 : (rank === 2 ? .96 : .92);
    return Math.max(0, Math.min(100, Math.round(
      distanceScore * coverageFactor * rankFactor
    )));
  }
  function colourMatchLabel(percentage) {
    percentage = Number(percentage);
    if (percentage >= 95) return 'Excellent match';
    if (percentage >= 85) return 'Very close';
    if (percentage >= 70) return 'Close match';
    if (percentage >= 55) return 'Similar shade';
    return 'Related shade';
  }

  function initialise(root) {
    if (root.getAttribute('data-ready') === 'true') return;
    root.setAttribute('data-ready', 'true');
    // Colour-family pages mount their one existing shade component directly
    // below the global spectrum before this controller starts. Read controls
    // from that external host while retaining the catalogue root for results.
    var mountedFamilyPicker = document.querySelector(
      '[data-pw-family-shade-host] [data-pw-family-shade-picker]'
    );
    var controlRoot = mountedFamilyPicker || root;
    var customColourOpen = controlRoot.querySelector('[data-colour-custom-open]');
    var customColourSwatch = controlRoot.querySelector('[data-colour-custom-swatch]');
    var customColourCopy = controlRoot.querySelector('[data-colour-custom-copy]');
    var customDialog = controlRoot.querySelector('[data-colour-custom-dialog]');
    var customPanel = controlRoot.querySelector('[data-colour-custom-panel]');
    var customPreview = controlRoot.querySelector('[data-colour-custom-preview]');
    var customName = controlRoot.querySelector('[data-colour-custom-name]');
    var customValue = controlRoot.querySelector('[data-colour-custom-value]');
    var customHexInput = controlRoot.querySelector('[data-colour-custom-hex]');
    var customHue = controlRoot.querySelector('[data-colour-custom-hue]');
    var customSaturation = controlRoot.querySelector('[data-colour-custom-saturation]');
    var customBrightness = controlRoot.querySelector('[data-colour-custom-brightness]');
    var customHueOutput = controlRoot.querySelector('[data-colour-custom-hue-output]');
    var customSaturationOutput = controlRoot.querySelector('[data-colour-custom-saturation-output]');
    var customBrightnessOutput = controlRoot.querySelector('[data-colour-custom-brightness-output]');
    var customApply = controlRoot.querySelector('[data-colour-custom-apply]');
    var customCancelButtons = controlRoot.querySelectorAll('[data-colour-custom-cancel]');
    var photoOpen = controlRoot.querySelector('[data-colour-photo-open]');
    var photoInput = controlRoot.querySelector('[data-colour-file]');
    var photoDialog = controlRoot.querySelector('[data-colour-photo-dialog]');
    var photoPanel = controlRoot.querySelector('[data-colour-photo-panel]');
    var photoCloseButtons = controlRoot.querySelectorAll('[data-colour-photo-close]');
    var photoView = controlRoot.querySelector('[data-colour-photo-view]');
    var photoFooter = controlRoot.querySelector('[data-colour-photo-footer]');
    var photoError = controlRoot.querySelector('[data-colour-photo-error]');
    var photoCanvas = controlRoot.querySelector('[data-colour-photo]');
    var photoWrap = controlRoot.querySelector('[data-colour-photo-wrap]');
    var photoStage = controlRoot.querySelector('[data-colour-photo-stage]');
    var photoMarker = controlRoot.querySelector('[data-colour-photo-marker]');
    var photoHint = controlRoot.querySelector('[data-colour-photo-hint]');
    var photoReplace = controlRoot.querySelector('[data-colour-photo-replace]');
    var photoOptions = controlRoot.querySelector('[data-colour-photo-options]');
    var photoOptionList = controlRoot.querySelector('[data-colour-photo-option-list]');
    var photoSelectedSwatch = controlRoot.querySelector('[data-colour-photo-selected-swatch]');
    var photoSelectedName = controlRoot.querySelector('[data-colour-photo-selected-name]');
    var photoSelectedValue = controlRoot.querySelector('[data-colour-photo-selected-value]');
    var photoSelectedCoverage = controlRoot.querySelector('[data-colour-photo-selected-coverage]');
    var dropzone = controlRoot.querySelector('[data-colour-dropzone]');
    var picker = controlRoot.querySelector('[data-colour-picker]');
    var pickerField = controlRoot.querySelector('[data-colour-picker-field]');
    var pickerHue = controlRoot.querySelector('[data-colour-hue]');
    var pickerEyedropper = controlRoot.querySelector('[data-colour-eyedropper]');
    var pickerWrap = controlRoot.querySelector('.pwcolour__picker-wrap') ||
      (controlRoot.matches && controlRoot.matches('.pwcolour__picker-wrap') ? controlRoot : null);
    var browseApp = root.querySelector('#PrewornWideSearch');
    var grid = root.querySelector('[data-colour-grid]');
    var loading = root.querySelector('[data-colour-loading]');
    var error = controlRoot.querySelector('[data-colour-error]') ||
      root.querySelector('[data-colour-error]');
    var pagination = root.querySelector('[data-colour-pagination]');
    var endpoint = root.getAttribute('data-catalog-api') || '';
    var colourFamily = String(root.getAttribute('data-colour-family') || '').trim();
    var hueRange = familyHueRange(colourFamily);

    // Older deployed copies of the family-page Liquid placed a labelled hue
    // slider in its own controls row and the catalogue shades below it. Repair
    // that legacy DOM from the asset too, so an asset update cannot leave
    // "EXPLORE [COLOUR] HUES" visible while Shopify is still serving cached
    // section markup.
    function normaliseFamilyPickerActions() {
      if (!colourFamily || !picker) return;
      var controls = picker.querySelector('.pwcolour__picker-controls');
      var familyShades = picker.querySelector('.pwcolour__family-shades');
      var legacyHue = controls && controls.querySelector('.pwcolour__picker-hue');
      if (legacyHue && legacyHue.parentNode) {
        legacyHue.parentNode.removeChild(legacyHue);
        pickerHue = null;
      }
      if (!controls || !familyShades) return;
      var actions = controls.parentNode;
      if (actions && actions.classList &&
          actions.classList.contains('pwcolour__picker-actions--family')) return;
      actions = document.createElement('div');
      actions.className = 'pwcolour__picker-actions pwcolour__picker-actions--family';
      controls.parentNode.insertBefore(actions, controls);
      actions.appendChild(controls);
      actions.appendChild(familyShades);
    }

    normaliseFamilyPickerActions();
    var pageParameters = new URL(window.location.href).searchParams;
    var nominalColourParameter = String(pageParameters.get('colour') || '').trim();
    var requestedNominalColour = validHex(nominalColourParameter)
      ? '' : nominalColourParameter;
    var requestedColour = pageParameters.get('colour_hex') ||
      (validHex(nominalColourParameter) ? nominalColourParameter : '');
    if (!validHex(requestedColour)) requestedColour = '';
    var initial = requestedColour || root.getAttribute('data-initial-colour') || '#5278A7';
    if (!validHex(initial)) initial = '#5278A7';
    initial = initial.toUpperCase();

    function constrainToFamily(hex) {
      if (!hueRange || !validHex(hex)) return hex;
      var rgb = hexRgb(hex);
      var hsv = rgbHsv(rgb.r, rgb.g, rgb.b);
      var saturationLimit = Number(hueRange.maxSaturation || 100);
      return hsvHex(
        hueForRange(hsv.h, hueRange),
        Math.min(hsv.s, saturationLimit),
        hsv.v
      );
    }

    initial = constrainToFamily(initial).toUpperCase();
    var state = {
      hex: initial,
      tolerance: clamp(Number(pageParameters.get('colour_tolerance') || 12) || 12, 3, 20),
      page: 1,
      searched: false,
      timer: null,
      controller: null,
      photoImage: null,
      photoClusters: [],
      photoMarker: null,
      photoDraw: null
    };
    var customDraftHex = state.hex;
    var customLastFocus = null;
    var photoLastFocus = null;
    var activeNominalColour = requestedNominalColour;

    function paintNominalColour(colour, pickerHex) {
      activeNominalColour = String(colour || '').trim();
      var displayHex = validHex(pickerHex)
        ? String(pickerHex).toUpperCase()
        : nominalColourPickerHex(activeNominalColour);
      if (displayHex) updateSelection(displayHex, false);
      root.querySelectorAll('[data-colour-filter]').forEach(function (button) {
        button.classList.toggle(
          'is-active',
          String(button.getAttribute('data-colour-filter') || '').toLowerCase() ===
            activeNominalColour.toLowerCase()
        );
      });
    }

    function renderCustomIdentity(hex) {
      customDraftHex = String(hex || '').toUpperCase();
      if (customPreview) customPreview.style.background = customDraftHex;
      if (customName) customName.textContent = friendlyName(customDraftHex);
      if (customValue) customValue.textContent = customDraftHex;
      if (customHexInput && document.activeElement !== customHexInput) {
        customHexInput.value = customDraftHex;
      }
      if (customPanel) {
        customPanel.style.setProperty('--pw-custom-colour', customDraftHex);
      }
    }

    function renderCustomDraft(hue, saturation, brightness) {
      hue = clamp(Math.round(Number(hue) || 0), 0, 359);
      saturation = clamp(Math.round(Number(saturation) || 0), 0, 100);
      brightness = clamp(Math.round(Number(brightness) || 0), 0, 100);

      if (customHue) customHue.value = String(hue);
      if (customSaturation) customSaturation.value = String(saturation);
      if (customBrightness) customBrightness.value = String(brightness);
      if (customHueOutput) customHueOutput.textContent = hue + '°';
      if (customSaturationOutput) customSaturationOutput.textContent = saturation + '%';
      if (customBrightnessOutput) customBrightnessOutput.textContent = brightness + '%';
      renderCustomIdentity(hsvHex(hue, saturation, brightness));
      if (customPanel) {
        customPanel.style.setProperty('--pw-custom-saturation-track',
          'linear-gradient(90deg, ' + hsvHex(hue, 0, brightness) + ', ' + hsvHex(hue, 100, brightness) + ')');
        customPanel.style.setProperty('--pw-custom-brightness-track',
          'linear-gradient(90deg, #000000, ' + hsvHex(hue, saturation, 100) + ')');
      }
    }

    function seedCustomControls(hex) {
      if (!validHex(hex)) return;
      var rgb = hexRgb(hex);
      var hsv = rgbHsv(rgb.r, rgb.g, rgb.b);
      renderCustomDraft(hsv.h, hsv.s, hsv.v);
      // Range controls use whole-number steps; retain the exact source HEX until
      // the customer actually moves a control so opening and applying is lossless.
      renderCustomIdentity(hex);
    }

    function updateCustomFromSliders() {
      if (!customHue || !customSaturation || !customBrightness) return;
      renderCustomDraft(customHue.value, customSaturation.value, customBrightness.value);
    }

    function openCustomDialog() {
      if (!customDialog) return;
      customLastFocus = document.activeElement;
      seedCustomControls(state.hex);
      customDialog.hidden = false;
      document.body.classList.add('pwcolour-custom-open');
      window.requestAnimationFrame(function () {
        if (!customHue) return;
        try { customHue.focus({ preventScroll: true }); }
        catch (error) { customHue.focus(); }
      });
    }

    function closeCustomDialog(restoreFocus) {
      if (!customDialog) return;
      customDialog.hidden = true;
      document.body.classList.remove('pwcolour-custom-open');
      if (restoreFocus !== false && customLastFocus && typeof customLastFocus.focus === 'function') {
        try { customLastFocus.focus({ preventScroll: true }); }
        catch (error) { customLastFocus.focus(); }
      }
    }

    function choosePhotoFile() {
      if (!photoInput) return;
      photoInput.value = '';
      photoInput.click();
    }

    function openPhotoDialog(force) {
      if (!photoDialog || (!state.photoImage && !force)) return;
      if (photoDialog.hidden) photoLastFocus = document.activeElement;
      photoDialog.hidden = false;
      document.body.classList.add('pwcolour-photo-open');
      window.requestAnimationFrame(function () {
        if (state.photoImage) drawPhotoForDisplay(state.photoImage);
        var closeButton = photoDialog.querySelector('[data-colour-photo-close]');
        if (!closeButton) return;
        try { closeButton.focus({ preventScroll: true }); }
        catch (error) { closeButton.focus(); }
      });
    }

    function closePhotoDialog(restoreFocus) {
      if (!photoDialog) return;
      photoDialog.hidden = true;
      document.body.classList.remove('pwcolour-photo-open');
      if (restoreFocus !== false && photoLastFocus && typeof photoLastFocus.focus === 'function') {
        try { photoLastFocus.focus({ preventScroll: true }); }
        catch (error) { photoLastFocus.focus(); }
      }
    }

    function mountPickerAboveWardrobe() {
      if (!pickerWrap || !browseApp) return false;
      if (pickerWrap.closest && pickerWrap.closest('[data-pw-family-shade-host]')) return true;
      var wardrobe = browseApp.querySelector('#PrewornWardrobeSearchToggle');
      if (!wardrobe || !wardrobe.parentNode) return false;
      pickerWrap.classList.add('pwcolour__picker-wrap--embedded');
      wardrobe.parentNode.insertBefore(pickerWrap, wardrobe);
      return true;
    }

    function mountStandalonePickerFullWidth() {
      if (!pickerWrap) return false;
      var browseResults = root.querySelector('.pwcolour__browse-results');
      if (!browseResults || browseResults.parentNode !== root) return false;
      pickerWrap.classList.remove('pwcolour__picker-wrap--embedded');
      pickerWrap.classList.add('pwcolour__picker-wrap--full-width');
      if (pickerWrap.parentNode !== root || pickerWrap.nextElementSibling !== browseResults) {
        root.insertBefore(pickerWrap, browseResults);
      }
      return true;
    }

    if (!colourFamily) {
      mountStandalonePickerFullWidth();
      if (typeof window.MutationObserver === 'function') {
        var standalonePickerObserver = new window.MutationObserver(function () {
          mountStandalonePickerFullWidth();
        });
        standalonePickerObserver.observe(root, { childList: true, subtree: true });
      }
    } else if (!mountPickerAboveWardrobe() && browseApp && typeof window.MutationObserver === 'function') {
      var pickerMountObserver = new window.MutationObserver(function () {
        if (!mountPickerAboveWardrobe()) return;
        pickerMountObserver.disconnect();
      });
      pickerMountObserver.observe(browseApp, { childList: true, subtree: true });
    }

    if (pickerHue && hueRange) {
      pickerHue.min = String(hueRange.start);
      pickerHue.max = String(hueRange.end);
      pickerHue.setAttribute('aria-valuemin', String(hueRange.start));
      pickerHue.setAttribute('aria-valuemax', String(hueRange.end));
      pickerHue.style.background = familyHueGradient(hueRange);
      root.classList.toggle('pwcolour--family-neutral', !!hueRange.neutral);
      var pickerHost = pickerWrap && pickerWrap.closest ? pickerWrap.closest('.pwcolour') : null;
      if (pickerHost) pickerHost.classList.toggle('pwcolour--family-neutral', !!hueRange.neutral);
    }

    function renderPicker(hex) {
      if (!picker || !validHex(hex)) return;
      var rgb = hexRgb(hex);
      var hsv = rgbHsv(rgb.r, rgb.g, rgb.b);
      var displayHue = hueForRange(hsv.h, hueRange);
      var saturationLimit = hueRange ? Number(hueRange.maxSaturation || 100) : 100;
      picker.style.setProperty('--pw-picker-hue', String(Math.round(((displayHue % 360) + 360) % 360)));
      picker.style.setProperty('--pw-picker-colour', hex);
      picker.style.setProperty('--pw-picker-field-saturation', saturationLimit + '%');
      picker.style.setProperty('--pw-picker-x', clamp(hsv.s / saturationLimit * 100, 0, 100) + '%');
      picker.style.setProperty('--pw-picker-y', (100 - hsv.v) + '%');
      if (pickerHue && document.activeElement !== pickerHue) {
        pickerHue.value = Math.round(displayHue);
      }
      if (pickerField) {
        pickerField.setAttribute('aria-valuenow', String(Math.round(hsv.v)));
        pickerField.setAttribute('aria-valuetext', friendlyName(hex) + ', ' + hex);
      }
    }

    function updateSelection(hex, queue) {
      if (!validHex(hex)) return;
      state.hex = constrainToFamily(hex).toUpperCase();
      if (customColourSwatch) customColourSwatch.style.setProperty('--shade', state.hex);
      if (customColourCopy) {
        customColourCopy.textContent = friendlyName(state.hex) + ' · ' + state.hex;
      }
      if (photoSelectedSwatch) photoSelectedSwatch.style.setProperty('--photo-selected', state.hex);
      if (photoSelectedName) photoSelectedName.textContent = friendlyName(state.hex);
      if (photoSelectedValue) photoSelectedValue.textContent = state.hex;
      renderPicker(state.hex);
      var resultSwatch = root.querySelector('[data-result-swatch]');
      var resultsName = root.querySelector('[data-results-name]');
      if (resultSwatch) resultSwatch.style.background = state.hex;
      if (resultsName) resultsName.textContent = friendlyName(state.hex);
      if (photoOptionList) {
        photoOptionList.querySelectorAll('[data-colour-photo-option]').forEach(function (button) {
          button.classList.toggle(
            'is-active',
            String(button.getAttribute('data-colour-photo-option') || '').toUpperCase() === state.hex
          );
        });
      }
      if (queue) queueSearch();
    }
    if (customColourOpen) customColourOpen.addEventListener('click', openCustomDialog);
    if (photoOpen) {
      photoOpen.addEventListener('click', function () {
        if (state.photoImage) openPhotoDialog();
        else choosePhotoFile();
      });
    }
    [customHue, customSaturation, customBrightness].forEach(function (input) {
      if (input) input.addEventListener('input', updateCustomFromSliders);
    });
    if (customHexInput) {
      customHexInput.addEventListener('input', function () {
        var typed = String(customHexInput.value || '').trim();
        if (/^[0-9a-f]{6}$/i.test(typed)) typed = '#' + typed;
        customHexInput.classList.toggle('is-invalid', !validHex(typed));
        if (validHex(typed)) seedCustomControls(typed.toUpperCase());
      });
    }
    if (customApply) {
      customApply.addEventListener('click', function () {
        updateSelection(customDraftHex, false);
        closeCustomDialog(true);
        search(1);
      });
    }
    customCancelButtons.forEach(function (button) {
      button.addEventListener('click', function () { closeCustomDialog(true); });
    });
    if (customDialog) {
      customDialog.addEventListener('click', function (event) {
        if (event.target === customDialog) closeCustomDialog(true);
      });
      customDialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeCustomDialog(true);
          return;
        }
        if (event.key !== 'Tab' || !customPanel) return;
        var focusable = Array.prototype.slice.call(customPanel.querySelectorAll('button, input'))
          .filter(function (element) { return !element.disabled && element.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }
    photoCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () { closePhotoDialog(true); });
    });
    if (photoView) {
      photoView.addEventListener('click', function () {
        closePhotoDialog(false);
        var target = root.querySelector('.pwcolour__browse-results') || browseApp;
        if (target && typeof target.scrollIntoView === 'function') {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    if (photoDialog) {
      photoDialog.addEventListener('click', function (event) {
        if (event.target === photoDialog) closePhotoDialog(true);
      });
      photoDialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closePhotoDialog(true);
          return;
        }
        if (event.key !== 'Tab' || !photoPanel) return;
        var focusable = Array.prototype.slice.call(
          photoPanel.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])')
        ).filter(function (element) { return !element.disabled && element.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }
    root.querySelectorAll('[data-colour-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        var colour = String(button.getAttribute('data-colour-filter') || '').trim();
        var nextColour = colour.toLowerCase() === activeNominalColour.toLowerCase()
          ? '' : colour;
        if (browseApp) {
          window.dispatchEvent(new CustomEvent('preworn:nominal-colour-change', {
            detail: { colour: nextColour || colour }
          }));
          return;
        }
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.delete('colour_hex');
        nextUrl.searchParams.delete('colour_tolerance');
        if (nextColour) nextUrl.searchParams.set('colour', nextColour);
        else nextUrl.searchParams.delete('colour');
        window.location.assign(nextUrl.pathname + nextUrl.search + nextUrl.hash);
      });
    });

    var pickerDragging = false;
    function updatePickerFromPointer(event) {
      if (!pickerField) return;
      var rectangle = pickerField.getBoundingClientRect();
      if (!rectangle.width || !rectangle.height) return;
      var current = hexRgb(state.hex);
      var currentHsv = rgbHsv(current.r, current.g, current.b);
      var saturationLimit = hueRange ? Number(hueRange.maxSaturation || 100) : 100;
      var saturation = clamp((event.clientX - rectangle.left) / rectangle.width * saturationLimit, 0, saturationLimit);
      var value = clamp(100 - (event.clientY - rectangle.top) / rectangle.height * 100, 0, 100);
      updateSelection(hsvHex(currentHsv.h, saturation, value), true);
    }
    if (pickerField) {
      pickerField.addEventListener('pointerdown', function (event) {
        pickerDragging = true;
        if (pickerField.setPointerCapture) {
          try { pickerField.setPointerCapture(event.pointerId); } catch (error) {}
        }
        updatePickerFromPointer(event);
      });
      pickerField.addEventListener('pointermove', function (event) {
        if (pickerDragging) updatePickerFromPointer(event);
      });
      pickerField.addEventListener('pointerup', function (event) {
        if (pickerDragging) updatePickerFromPointer(event);
        pickerDragging = false;
      });
      pickerField.addEventListener('pointercancel', function () { pickerDragging = false; });
      pickerField.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(event.key) === -1) return;
        event.preventDefault();
        var current = hexRgb(state.hex);
        var hsv = rgbHsv(current.r, current.g, current.b);
        var saturationLimit = hueRange ? Number(hueRange.maxSaturation || 100) : 100;
        if (event.key === 'ArrowLeft') hsv.s -= 2;
        else if (event.key === 'ArrowRight') hsv.s += 2;
        else if (event.key === 'ArrowUp') hsv.v += 2;
        else if (event.key === 'ArrowDown') hsv.v -= 2;
        else if (event.key === 'Home') hsv.s = 0;
        else hsv.s = saturationLimit;
        hsv.s = clamp(hsv.s, 0, saturationLimit);
        updateSelection(hsvHex(hsv.h, hsv.s, hsv.v), true);
      });
    }
    if (pickerHue) {
      pickerHue.addEventListener('input', function () {
        var current = hexRgb(state.hex);
        var hsv = rgbHsv(current.r, current.g, current.b);
        updateSelection(hsvHex(Number(pickerHue.value), hsv.s, hsv.v), true);
      });
    }
    window.addEventListener('preworn:exact-colour-state', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (!colourFamily) {
        if (validHex(detail.hex)) updateSelection(String(detail.hex).toUpperCase(), false);
        return;
      }
      if (!validHex(detail.hex)) {
        updateSelection(initial, false);
        return;
      }
      var requestedHex = String(detail.hex).toUpperCase();
      var constrainedHex = constrainToFamily(requestedHex).toUpperCase();
      updateSelection(constrainedHex, false);
      if (constrainedHex !== requestedHex) {
        window.dispatchEvent(new CustomEvent('preworn:exact-colour-change', {
          detail: {
            hex: constrainedHex,
            tolerance: detail.tolerance || state.tolerance,
            name: friendlyName(constrainedHex)
          }
        }));
      }
    });
    window.addEventListener('preworn:nominal-colour-state', function (event) {
      var detail = event && event.detail ? event.detail : {};
      paintNominalColour(detail.colour, detail.pickerHex);
    });
    if (pickerEyedropper && typeof window.EyeDropper !== 'function') {
      pickerEyedropper.title = 'Customise an exact colour';
      pickerEyedropper.setAttribute('aria-label', 'Customise an exact colour');
      pickerEyedropper.addEventListener('click', openCustomDialog);
    } else if (pickerEyedropper) {
      pickerEyedropper.addEventListener('click', function () {
        new window.EyeDropper().open().then(function (result) {
          if (!result || !validHex(result.sRGBHex)) return;
          updateSelection(result.sRGBHex, false);
          search(1);
        }).catch(function () {});
      });
    }

    function queueSearch() {
      window.clearTimeout(state.timer);
      state.timer = window.setTimeout(function () { search(1); }, 320);
    }

    function wardrobeScope() {
      if (!window.PrewornWardrobe ||
          typeof window.PrewornWardrobe.isActive !== 'function' ||
          !window.PrewornWardrobe.isActive() ||
          typeof window.PrewornWardrobe.getScopeParams !== 'function') return {};
      return window.PrewornWardrobe.getScopeParams() || {};
    }

    function renderPhotoOptions(clusters) {
      if (!photoOptions || !photoOptionList) return;
      if (!clusters.length) {
        photoOptionList.innerHTML = '';
        photoOptions.hidden = true;
        return;
      }
      photoOptionList.innerHTML = clusters.map(function (cluster, index) {
        var name = friendlyName(cluster.hex);
        var coverage = Math.max(1, Math.min(100, Math.round(cluster.coverage * 100)));
        return '<button type="button" data-colour-photo-option="' + cluster.hex + '" ' +
          'data-photo-x="' + cluster.x + '" data-photo-y="' + cluster.y + '" ' +
          'data-photo-coverage="' + cluster.coverage + '" ' +
          'aria-label="Search ' + escapeHtml(name) + ', ' + coverage +
          ' percent of photo, ' + cluster.hex + '">' +
            '<i style="--photo-colour:' + cluster.hex + '"></i>' +
            '<span><strong>' + escapeHtml(name) + '</strong>' +
            '<small>' + coverage + '% · ' + cluster.hex +
            (index === 0 ? ' · Dominant' : '') + '</small></span>' +
            '<b class="pwcolour__photo-option-percent">' + coverage + '%</b>' +
          '</button>';
      }).join('');
      photoOptions.hidden = false;
    }

    function renderPhotoCoverage(coverage) {
      if (!photoSelectedCoverage) return;
      var numericCoverage = Math.max(0, Math.min(1, Number(coverage) || 0));
      photoSelectedCoverage.textContent = numericCoverage > 0
        ? '· ' + Math.max(1, Math.round(numericCoverage * 100)) + '% OF PHOTO'
        : '· <1% OF PHOTO';
    }

    function nearestPhotoCoverage(hex) {
      if (!validHex(hex) || !state.photoClusters.length) return 0;
      var rgb = hexRgb(hex);
      var targetLab = rgbLab(rgb.r, rgb.g, rgb.b);
      var nearest = null, nearestDistance = Infinity;
      state.photoClusters.forEach(function (cluster) {
        var clusterRgb = hexRgb(cluster.hex);
        var distance = labDistance(
          targetLab,
          rgbLab(clusterRgb.r, clusterRgb.g, clusterRgb.b)
        );
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = cluster;
        }
      });
      return nearest ? nearest.coverage : 0;
    }

    function sizePhotoStage(image) {
      if (!photoStage || !image) return;
      var trayStyle = photoWrap ? window.getComputedStyle(photoWrap) : null;
      var horizontalPadding = trayStyle
        ? (parseFloat(trayStyle.paddingLeft) || 0) + (parseFloat(trayStyle.paddingRight) || 0)
        : 0;
      var availableWidth = Math.max(1, (photoWrap ? photoWrap.clientWidth : photoStage.clientWidth) - horizontalPadding);
      var aspect = Math.max(.1, image.naturalWidth / Math.max(1, image.naturalHeight));
      var compact = window.matchMedia && window.matchMedia('(max-width: 700px)').matches;
      var heightLimit = compact
        ? Math.min(220, Math.max(110, window.innerHeight * .24))
        : Math.min(360, Math.max(160, window.innerHeight * .34));
      var height = Math.min(availableWidth / aspect, heightLimit);
      var width = Math.min(availableWidth, height * aspect);
      photoStage.style.width = Math.max(1, Math.round(width)) + 'px';
      photoStage.style.height = Math.max(1, Math.round(height)) + 'px';
      photoStage.style.marginInline = 'auto';
    }

    function drawPhotoForDisplay(image) {
      if (!photoCanvas) return;
      sizePhotoStage(image);
      var rect = photoStage
        ? photoStage.getBoundingClientRect()
        : (dropzone ? dropzone.getBoundingClientRect() : { width: 900, height: 360 });
      var cssWidth = Math.max(1, Math.round(rect.width || 900));
      var cssHeight = Math.max(1, Math.round(rect.height || 360));
      var pixelRatio = Math.max(1, Math.min(2, Number(window.devicePixelRatio) || 1));
      var width = Math.min(1000, Math.round(cssWidth * pixelRatio));
      var height = Math.max(1, Math.round(width * cssHeight / cssWidth));
      photoCanvas.width = width;
      photoCanvas.height = height;
      var context = photoCanvas.getContext('2d', { willReadFrequently: true });
      context.clearRect(0, 0, width, height);
      var scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
      var drawWidth = Math.max(1, Math.round(image.naturalWidth * scale));
      var drawHeight = Math.max(1, Math.round(image.naturalHeight * scale));
      var drawX = Math.round((width - drawWidth) / 2);
      var drawY = Math.round((height - drawHeight) / 2);
      context.drawImage(
        image,
        drawX,
        drawY,
        drawWidth,
        drawHeight
      );
      state.photoDraw = { x: drawX, y: drawY, width: drawWidth, height: drawHeight };
      positionPhotoMarker(state.photoMarker);
    }

    function positionPhotoMarker(marker) {
      state.photoMarker = marker || null;
      if (!photoMarker || !photoCanvas || !state.photoMarker || !state.photoDraw) {
        if (photoMarker) photoMarker.hidden = true;
        return;
      }
      var rect = photoCanvas.getBoundingClientRect();
      var draw = state.photoDraw;
      var internalX = draw.x + clamp(Number(state.photoMarker.x) || 0, 0, 1) * draw.width;
      var internalY = draw.y + clamp(Number(state.photoMarker.y) || 0, 0, 1) * draw.height;
      photoMarker.style.left = (internalX * rect.width / photoCanvas.width) + 'px';
      photoMarker.style.top = (internalY * rect.height / photoCanvas.height) + 'px';
      photoMarker.style.background = state.photoMarker.hex;
      photoMarker.hidden = false;
    }

    function samplePhoto(image) {
      var analysis = document.createElement('canvas');
      // Match the catalogue index: analyse a 200px copy, while the separate
      // display canvas retains enough resolution for precise manual sampling.
      var scale = Math.min(1, 200 / Math.max(image.naturalWidth, image.naturalHeight));
      analysis.width = Math.max(1, Math.round(image.naturalWidth * scale));
      analysis.height = Math.max(1, Math.round(image.naturalHeight * scale));
      analysis.getContext('2d', { willReadFrequently: true }).drawImage(
        image, 0, 0, analysis.width, analysis.height
      );
      return dominantPhotoColours(analysis);
    }

    function usePhotoFile(file) {
      if (!file || !/^image\/(?:png|jpeg|webp)$/i.test(file.type || '') || file.size > 12 * 1024 * 1024) {
        showPhotoError('Choose a JPG, PNG or WebP image smaller than 12 MB.');
        openPhotoDialog(true);
        return;
      }
      clearPhotoError();
      var reader = new FileReader();
      reader.onload = function () {
        var image = new Image();
        image.onload = function () {
          var clusters = samplePhoto(image);
          state.photoImage = image;
          state.photoClusters = clusters;
          if (dropzone) dropzone.hidden = true;
          if (photoWrap) photoWrap.hidden = false;
          if (photoFooter) photoFooter.hidden = false;
          state.photoMarker = clusters.length ? {
            x: clusters[0].x,
            y: clusters[0].y,
            hex: clusters[0].hex
          } : null;
          clearPhotoError();
          renderPhotoOptions(clusters);
          if (photoHint) {
            photoHint.textContent = clusters.length
              ? 'Tap the photo to pick another colour.'
              : 'Tap the photo to pick a colour.';
          }
          if (clusters.length) {
            updateSelection(clusters[0].hex, false);
            renderPhotoCoverage(clusters[0].coverage);
            search(1);
          } else {
            renderPhotoCoverage(0);
          }
          openPhotoDialog();
        };
        image.onerror = function () {
          showPhotoError('That image could not be opened. Try another photo.');
          openPhotoDialog(true);
        };
        image.src = reader.result;
      };
      reader.onerror = function () {
        showPhotoError('That image could not be opened. Try another photo.');
        openPhotoDialog(true);
      };
      reader.readAsDataURL(file);
    }
    if (photoInput) {
      photoInput.addEventListener('change', function () { usePhotoFile(this.files && this.files[0]); });
    }
    if (photoReplace && photoInput) {
      photoReplace.addEventListener('click', choosePhotoFile);
    }
    if (photoOptionList) {
      photoOptionList.addEventListener('click', function (event) {
        var button = event.target.closest('[data-colour-photo-option]');
        if (!button || !photoOptionList.contains(button)) return;
        var hex = button.getAttribute('data-colour-photo-option');
        positionPhotoMarker({
          x: Number(button.getAttribute('data-photo-x')),
          y: Number(button.getAttribute('data-photo-y')),
          hex: hex
        });
        renderPhotoCoverage(Number(button.getAttribute('data-photo-coverage')));
        updateSelection(hex, false);
        search(1);
      });
    }
    if (dropzone) {
      ['dragenter', 'dragover'].forEach(function (name) { dropzone.addEventListener(name, function (event) { event.preventDefault(); dropzone.classList.add('is-dragging'); }); });
      ['dragleave', 'drop'].forEach(function (name) { dropzone.addEventListener(name, function (event) { event.preventDefault(); dropzone.classList.remove('is-dragging'); }); });
      dropzone.addEventListener('drop', function (event) { usePhotoFile(event.dataTransfer.files && event.dataTransfer.files[0]); });
    }
    if (photoCanvas) {
      photoCanvas.addEventListener('click', function (event) {
        var rect = photoCanvas.getBoundingClientRect();
        var x = clamp(Math.floor((event.clientX - rect.left) * photoCanvas.width / rect.width), 0, photoCanvas.width - 1);
        var y = clamp(Math.floor((event.clientY - rect.top) * photoCanvas.height / rect.height), 0, photoCanvas.height - 1);
        var pixel = photoCanvas.getContext('2d', { willReadFrequently: true }).getImageData(x, y, 1, 1).data;
        if (pixel[3] < 35) {
          if (photoHint) photoHint.textContent = 'Click on the visible photo to select a colour.';
          return;
        }
        if (photoMarker) {
          var draw = state.photoDraw || { x: 0, y: 0, width: photoCanvas.width, height: photoCanvas.height };
          positionPhotoMarker({
            x: clamp((x - draw.x) / Math.max(1, draw.width), 0, 1),
            y: clamp((y - draw.y) / Math.max(1, draw.height), 0, 1),
            hex: rgbHex(pixel[0], pixel[1], pixel[2])
          });
        }
        var selectedPhotoHex = rgbHex(pixel[0], pixel[1], pixel[2]);
        if (photoHint) photoHint.textContent = 'Custom colour selected from your photo.';
        renderPhotoCoverage(nearestPhotoCoverage(selectedPhotoHex));
        updateSelection(selectedPhotoHex, false); search(1);
      });
    }
    window.addEventListener('resize', function () {
      if (!state.photoImage || !photoDialog || photoDialog.hidden) return;
      drawPhotoForDisplay(state.photoImage);
    });

    function setLoading(value) {
      if (loading) loading.hidden = !value;
      root.setAttribute('aria-busy', value ? 'true' : 'false');
    }
    function clearError() { if (error) { error.textContent = ''; error.hidden = true; } }
    function clearPhotoError() { if (photoError) { photoError.textContent = ''; photoError.hidden = true; } }
    function showPhotoError(message) {
      if (photoError) { photoError.textContent = message; photoError.hidden = false; }
      else console.warn('[Preworn Colour Finder]', message);
    }
    function showError(message) {
      if (error) { error.textContent = message; error.hidden = false; }
      else console.warn('[Preworn Colour Finder]', message);
    }

    function paramsFor(page) {
      var params = new URLSearchParams({
        action: 'colour_search', hex: state.hex, tolerance: String(state.tolerance),
        page: String(page), limit: '48'
      });
      var scope = wardrobeScope();
      Object.keys(scope).forEach(function (key) { if (scope[key] != null && scope[key] !== '') params.set(key, scope[key]); });
      return params;
    }

    function search(page) {
      if (browseApp) {
        window.clearTimeout(state.timer);
        state.page = page || 1;
        state.searched = true;
        window.dispatchEvent(new CustomEvent('preworn:exact-colour-change', {
          detail: {
            hex: state.hex,
            tolerance: state.tolerance,
            name: friendlyName(state.hex)
          }
        }));
        return;
      }
      if (!endpoint) { showError('Colour search is not configured yet.'); return; }
      window.clearTimeout(state.timer); state.page = page || 1; state.searched = true;
      if (state.controller) state.controller.abort();
      state.controller = typeof window.AbortController === 'function' ? new AbortController() : null;
      setLoading(true); clearError(); pagination.innerHTML = '';
      var requestUrl = new URL(endpoint, window.location.href); requestUrl.search = paramsFor(state.page).toString();
      var options = { headers: { Accept: 'application/json' } };
      if (state.controller) options.signal = state.controller.signal;
      fetch(requestUrl.toString(), options).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok) throw new Error(payload.error || 'colour_search_failed');
          return payload;
        });
      }).then(render).catch(function (failure) {
        if (failure && failure.name === 'AbortError') return;
        showError('We couldn’t search by colour just now. Please try again in a moment.');
      }).then(function () { setLoading(false); });
    }

    function render(payload) {
      var items = Array.isArray(payload.items) ? payload.items : [];
      var colour = payload.selectedColour || {};
      var displayName = colour.name || friendlyName(state.hex);
      root.querySelector('[data-results-name]').textContent = displayName;
      root.querySelector('[data-selected-name]').textContent = displayName;
      var count = Number(payload.totalCount) || 0;
      root.querySelector('[data-results-count]').textContent = (payload.countIsEstimate ? 'More than ' : '') +
        count.toLocaleString('en-GB') + (count === 1 ? ' one-off item' : ' one-off items') +
        (Object.keys(wardrobeScope()).length ? ' in your Wardrobe' : '') +
        ' · closest matches first';
      var bands = payload.bands || {};
      root.querySelector('[data-band-exceptional]').textContent = Number(bands.exceptional || 0).toLocaleString('en-GB');
      root.querySelector('[data-band-very-close]').textContent = Number(bands.veryClose || 0).toLocaleString('en-GB');
      root.querySelector('[data-band-close]').textContent = Number(bands.close || 0).toLocaleString('en-GB');
      root.querySelector('[data-band-similar]').textContent = Number(bands.similar || 0).toLocaleString('en-GB');
      root.querySelector('[data-colour-bands]').hidden = false;

      if (!items.length) {
        grid.innerHTML = '<li class="pwcolour__empty"><strong>No close matches yet</strong>' +
          '<span>Try moving the sensitivity towards Broader or choose a neighbouring shade.</span></li>';
      } else if (window.PrewornProductCards && typeof window.PrewornProductCards.renderList === 'function') {
        grid.innerHTML = window.PrewornProductCards.renderList(items);
        window.PrewornProductCards.bindWishlist(grid);
      } else {
        grid.innerHTML = items.map(function (item) {
          var image = item.featuredImage || {};
          return '<li><a href="' + escapeHtml(item.onlineStoreUrl || ('/products/' + item.handle)) + '">' +
            '<img loading="lazy" src="' + escapeHtml(image.url || '') + '" alt="' + escapeHtml(image.altText || item.title) + '">' +
            '<strong>' + escapeHtml(item.vendor || '') + '</strong><span>' + escapeHtml(item.title || '') + '</span></a></li>';
        }).join('');
      }
      Array.prototype.forEach.call(items.length ? grid.children : [], function (card, index) {
        var match = items[index] && items[index].visualColour;
        var media = card.querySelector('.pw-card__media') || card;
        if (!match || !media) return;
        var chip = document.createElement('span');
        var matchPercentage = colourMatchPercentage(match);
        chip.className = 'pwcolour__match-chip';
        chip.style.setProperty('--match-colour', match.matchedHex || state.hex);
        chip.innerHTML = '<i></i>' + escapeHtml(colourMatchLabel(matchPercentage)) + ' · ' +
          escapeHtml(matchPercentage) + '% match';
        media.appendChild(chip);
      });
      renderPagination(payload);
      var currentUrl = new URL(window.location.href); currentUrl.searchParams.set('colour_hex', state.hex);
      window.history.replaceState({}, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
      var results = root.querySelector('.pwcolour__results');
      if (state.page > 1 && results) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderPagination(payload) {
      var totalPages = Number(payload.totalPages) || 0;
      if (totalPages <= 1) { pagination.innerHTML = ''; return; }
      pagination.innerHTML = '<button type="button" data-page="' + (state.page - 1) + '"' + (state.page <= 1 ? ' disabled' : '') + '>Previous</button>' +
        '<span>Page ' + state.page + ' of ' + totalPages + '</span>' +
        '<button type="button" data-page="' + (state.page + 1) + '"' + (state.page >= totalPages ? ' disabled' : '') + '>Next</button>';
      pagination.querySelectorAll('[data-page]').forEach(function (button) {
        button.addEventListener('click', function () { if (!button.disabled) search(Number(button.getAttribute('data-page'))); });
      });
    }

    updateSelection(initial, false);
    paintNominalColour(requestedNominalColour);
    if (!colourFamily && !requestedNominalColour) window.setTimeout(function () { search(1); }, 0);
    else if (validHex(requestedColour)) window.setTimeout(function () { search(1); }, 0);
  }

  roots.forEach(initialise);
})();
